module.exports = __webpack_public_path__ + "static/media/Banner-1200x800-1.f211de59.jpg";